/* assets/littleg-project-composer.js — GPROPERTY & GCITYPARTNERS EMPOWERED ENGINE
 * Version: v4.26-p0-geo-generator-delivery-loop
 * Owner: Scene selection rail, step state, clue visual sync, spatial pin, card generator & 2D export.
 * Architectural Handoff: GProperty Spatial Map & GCityPartners B2B Brief Form.
 * Contract Authority: Repo A Result Envelope & Mapbox Spatial HUD Rules
 */
(function () {
  'use strict';

  var VERSION = 'v4.26-p0-geo-generator-delivery-loop';
  if (window.__LITTLEG_PROJECT_COMPOSER_READY__ === VERSION) return;
  window.__LITTLEG_PROJECT_COMPOSER_READY__ = VERSION;

  var ROOT =
    '[data-littleg-project-composer].littleg-project-composer--home-campaign,[data-littleg-project-composer][data-entry-context="glg-main-homepage"]';

  /* Storage & Event Registry */
  var RESULT_KEY = 'littleg_result_history';
  var DELIVERY_KEY = 'littleg_delivery_history';
  var LATEST_KEY = 'littleg_drg_city_mission_latest';
  var EVENT_KEY = 'littleg_campaign_events_v1';
  var EXPORT_KEY = 'littleg_share_card_exports_v1';

  /* Mapbox & GCity Brand Copy */
  var HERO = {
    kicker: 'Dr.G 空間情報',
    title: '空間速查簡報',
    subtitle: '定位地點，即時產出空間評估。',
    support: '將現場觀察轉化為 GProperty 空間檔案，直通 GCityPartners 專家審查。',
  };

  var CARD_TITLE = '空間速查簡報';
  var CARD_HEADER = 'LittleG City Mission';
  var CHALLENGE = '我完成了今天的 +0.01% 任務，下一位輪到你。';
  var SUMMARY = '你的城市小發現，已變成一張可以分享的任務卡。';
  var DEFAULT_PLACE = '尚未標記位置。';
  var CLUE_TITLE = '這裡哪裡可以更好？';
  var CLUE_COPY = '不用答對，先找一個小發現。城市就 +0.01%。';

  var CONVERSION_LOOP = [
    'citizen_participation',
    'gis_context',
    'ai_generator',
    'shopify_digital_delivery',
  ];

  var AUDIT_QUESTIONS = [
    '是否在 5 秒內說清楚：市民可以做什麼？',
    '是否把一個觀察轉成可保存的資料點？',
    '是否保留 canonical scene_handle 供 GProperty GIS / 報告 / GCityPartners 使用？',
    '是否避免把遊戲結果偽裝成正式專業報告？',
    '是否提供 AI generator 的下一步，但不承諾未驗證後端？',
    '是否把 Shopify checkout / paid report 與免費任務卡分清楚？',
    '是否有 result history / delivery surface 可回看？',
    '是否有 GCityPartners Review escalation，而不是在首頁塞專業工作台？',
    '是否保留 GFun / backend write 的 owner Note？',
    '是否形成 citizen → GIS → AI → GCityPartners / Shopify delivery 的閉環入口？',
  ];

  /* 8 大場景方向 Mapbox & GCityPartners 視覺對齊 */
  var DIRECTIONS = {
    'land-detective': {
      title: '找土地線索',
      question: '哪裡空著、亂著，或邊界不清？',
      share: 'I found a land clue. Your City, +0.01% Today.',
      badge: '土地觀察員',
      badgeName: 'Land Clue Badge',
      score: '土地可以先從空置、邊界、通道或空間秩序開始 +0.01%。',
    },
    'engineering-delivery': {
      title: '找路口問題',
      question: '哪裡不好走、不好等，或不安全？',
      share: 'I found a street corner bug. Your City, +0.01% Today.',
      badge: '路口觀察員',
      badgeName: 'Street Corner Badge',
      score: '路口可以先從通行、等候、過路或安全感開始 +0.01%。',
    },
    'green-city': {
      title: '找舒服角落',
      question: '哪裡可以更涼、更乾淨、更舒服？',
      share: 'I found a comfort spot. Your City, +0.01% Today.',
      badge: '舒適觀察員',
      badgeName: 'Comfort Spot Badge',
      score: '環境可以先從遮蔭、清潔、熱感、綠化或舒適度開始 +0.01%。',
    },
    'industry-park': {
      title: '找園區待完善',
      question: '哪裡缺指示、缺休息點、缺配套？',
      share: 'I found a park gap. Your City, +0.01% Today.',
      badge: '園區觀察員',
      badgeName: 'Park Gap Badge',
      score: '園區可以先從指示、配套、入口、休息點或公共空間開始 +0.01%。',
    },
    'urban-renewal': {
      title: '找舊街亮點',
      question: '哪個角落變好一點，大家會更想來？',
      share: 'I found an old street clue. Your City, +0.01% Today.',
      badge: '舊街觀察員',
      badgeName: 'Old Street Badge',
      score: '舊街可以先從入口、路口、光線、休息點或停留感開始 +0.01%。',
    },
    'digital-city': {
      title: '找地圖錯漏',
      question: '哪里的指示、資訊或入口看不懂？',
      share: 'I found a map clue. Your City, +0.01% Today.',
      badge: '地圖觀察員',
      badgeName: 'Map Clue Badge',
      score: '地圖可以先從指示、資訊、定位、入口或服務說明開始 +0.01%。',
    },
    'water-resilience': {
      title: '找水邊提醒',
      question: '哪裡容易積水、滑倒，或需要提醒？',
      share: 'I found a water reminder. Your City, +0.01% Today.',
      badge: '水邊觀察員',
      badgeName: 'Water Reminder Badge',
      score: '水邊可以先從積水、排水、防滑、欄杆或提醒開始 +0.01%。',
    },
    'property-life-circle': {
      title: '找空間價值',
      question: '哪個地方被忽略，但其實可以更好用？',
      share: 'I found hidden space value. Your City, +0.01% Today.',
      badge: '空間觀察員',
      badgeName: 'Space Value Badge',
      score: '空間價值可以先從被忽略的入口、展示面、使用率或停留點開始 +0.01%。',
    },
  };

  /* GProperty & GCityPartners 標準化 Handle 映射 */
  var CANONICAL_SCENE_HANDLES = {
    'land-detective': 'land-natural-resources',
    'engineering-delivery': 'infrastructure-engineering',
    'green-city': 'green-city-service',
    'industry-park': 'industry-park-development',
    'urban-renewal': 'urban-renewal',
    'digital-city': 'digital-city',
    'water-resilience': 'water-resilience',
    'property-life-circle': 'property-assets-investment',
  };

  window.LITTLEG_GAME_CORE = {
    version: VERSION,
    hero: HERO,
    directions: DIRECTIONS,
    canonicalScenes: CANONICAL_SCENE_HANDLES,
    conversionLoop: CONVERSION_LOOP,
    auditQuestions: AUDIT_QUESTIONS,
    registryOwner: 'glg-market-registry',
    mode: 'geo-generator-delivery-loop',
  };

  /* Helper Functions */
  function q(r, s) {
    return r ? r.querySelector(s) : null;
  }
  function qa(r, s) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  }
  function attr(n, k) {
    return n ? n.getAttribute(k) || '' : '';
  }
  function setText(n, v) {
    if (n && v != null) n.textContent = String(v);
  }
  function norm(v) {
    return String(v || '')
      .trim()
      .toLowerCase()
      .replace(/_/g, '-');
  }

  function resolveRegistry(v) {
    var reg = window.GLGMarketRegistry;
    if (reg && typeof reg.resolve === 'function') {
      try {
        return reg.resolve(v) || null;
      } catch (_) {}
    }
    return null;
  }

  function normalizeZone(v) {
    var key = norm(v) || 'urban-renewal';
    var resolved = resolveRegistry(key);
    return resolved && (resolved.key || resolved.handle) ? resolved.key || resolved.handle : key;
  }

  function canonicalSceneHandle(key) {
    key = normalizeZone(key || 'urban-renewal');
    return CANONICAL_SCENE_HANDLES[key] || key;
  }

  /* Safe LocalStorage Protection */
  function canStore() {
    try {
      localStorage.setItem('__lg__', '1');
      localStorage.removeItem('__lg__');
      return true;
    } catch (e) {
      return false;
    }
  }

  function read(k, f) {
    if (!canStore()) return f;
    try {
      return JSON.parse(localStorage.getItem(k) || '') || f;
    } catch (e) {
      return f;
    }
  }

  function write(k, v) {
    if (!canStore()) return;
    try {
      localStorage.setItem(k, JSON.stringify(v));
    } catch (e) {}
  }

  function uid() {
    return 'city_mission_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }

  function emit(n, d, r) {
    try {
      window.dispatchEvent(new CustomEvent(n, { detail: d }));
      if (r) r.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: d }));
    } catch (e) {}
  }

  function track(root, name, data) {
    var list = read(EVENT_KEY, []);
    if (!Array.isArray(list)) list = [];
    list.unshift(
      Object.assign(
        { event: name, at: new Date().toISOString(), source: 'glg-home-main' },
        data || {}
      )
    );
    write(EVENT_KEY, list.slice(0, 160));
  }

  function append(raw, params, hash) {
    var u;
    try {
      u = new URL(raw || '/', location.origin);
    } catch (e) {
      u = new URL('/', location.origin);
    }
    Object.keys(params || {}).forEach(function (k) {
      if (params[k] != null && String(params[k]) !== '') u.searchParams.set(k, params[k]);
    });
    if (hash) u.hash = hash;
    return u.origin === location.origin ? u.pathname + u.search + u.hash : u.toString();
  }

  function cssVar(root, name) {
    try {
      return getComputedStyle(root).getPropertyValue(name).trim();
    } catch (e) {
      return '';
    }
  }

  /* Motion & Avatar State Controls */
  function pulse(node) {
    if (!node) return;
    var old = node.style.transform;
    node.style.transform = 'translate3d(0,-2px,0) scale(1.04)';
    window.setTimeout(function () {
      node.style.transform = old || '';
    }, 180);
  }

  function setMotion(root, state, data) {
    if (!(root instanceof HTMLElement)) return;
    root.setAttribute('data-motion-stage', state || 'idle');
    root.setAttribute('data-motionsites-runtime', VERSION);
    try {
      document.documentElement.setAttribute('data-littleg-motion-stage', state || 'idle');
    } catch (e) {}
    emit(
      'littleg:motion:stage',
      Object.assign({ stage: state || 'idle', version: VERSION }, data || {}),
      root
    );
  }

  function setStep(root, step) {
    setMotion(root, step || 'look');
    var map = { look: 0, choose: 1, write: 2, pin: 2, done: 3 };
    var index = map[step] == null ? 0 : map[step];
    root.setAttribute('data-mission-step', step || 'look');
    root.setAttribute('data-conversion-stage', step === 'done' ? 'delivery-ready' : step || 'look');

    qa(root, '.littleg-project-composer__loop span').forEach(function (node, i) {
      if (i === index) {
        node.setAttribute('aria-current', 'step');
        node.classList.add('is-active');
      } else {
        node.removeAttribute('aria-current');
        node.classList.remove('is-active');
      }
    });
  }

  function setAvatar(root, key, mode) {
    var avatar =
      q(root, '.littleg-project-composer__clue .drg-native-avatar') ||
      q(root, '.drg-native-avatar');
    if (!avatar) return;
    var value =
      mode === 'complete'
        ? cssVar(root, '--drg-avatar-proud-achiever')
        : cssVar(root, '--drg-avatar-' + key);
    value = value || cssVar(root, '--drg-avatar-default');
    if (value) avatar.style.setProperty('--drg-native-avatar-image', value);
    avatar.setAttribute('data-current-scene', key);
    avatar.setAttribute(
      'aria-label',
      mode === 'complete' ? 'Dr.G：收到！這張可以分享。' : 'Dr.G：看一下，哪裡怪怪的？'
    );
    if (mode !== 'silent') pulse(avatar);
  }

  function activeChip(root) {
    return (
      qa(root, '[data-composer-market-key]').filter(function (x) {
        return x.getAttribute('aria-pressed') === 'true';
      })[0] || q(root, '[data-composer-market-key]')
    );
  }

  function chipKey(chip) {
    return normalizeZone(attr(chip, 'data-composer-market-key') || 'urban-renewal');
  }

  function campaignFromChip(chip) {
    var key = chipKey(chip);
    var registryItem = resolveRegistry(key) || {};
    var f = DIRECTIONS[key] || DIRECTIONS['urban-renewal'];
    var canonical = attr(chip, 'data-canonical-scene-handle') || canonicalSceneHandle(key);

    return {
      key: key,
      canonical: canonical,
      handle: normalizeZone(
        attr(chip, 'data-composer-market-handle') || registryItem.handle || key
      ),
      title:
        attr(chip, 'data-composer-title') ||
        f.title ||
        registryItem.title_zh ||
        registryItem.title ||
        key,
      question:
        attr(chip, 'data-composer-question') ||
        f.question ||
        registryItem.human_question ||
        '這個地方可以怎樣 +0.01%？',
      share:
        attr(chip, 'data-composer-share-line') ||
        f.share ||
        registryItem.click_hook ||
        'I found one city clue. Your City, +0.01% Today.',
      badge:
        attr(chip, 'data-composer-badge-display-name') ||
        f.badge ||
        registryItem.badge_display_name ||
        '城市觀察員',
      badgeName: f.badgeName || registryItem.badge_name || 'City Mission Badge',
      score: f.score || registryItem.guide_line || '先找一個城市小發現，讓今天 +0.01%。',
    };
  }

  function setFold(root, name, open) {
    var d = q(root, '[data-lgc-fold="' + name + '"]');
    if (!d) return;
    d.open = !!open;
    root.setAttribute('data-' + name + '-expanded', open ? 'true' : 'false');
    var em = q(d, 'summary em');
    if (em) setText(em, open ? '收合' : '展開');
  }

  function syncFolds(root) {
    qa(root, '[data-lgc-fold]').forEach(function (d) {
      var name = attr(d, 'data-lgc-fold');
      root.setAttribute('data-' + name + '-expanded', d.open ? 'true' : 'false');
      var em = q(d, 'summary em');
      if (em) setText(em, d.open ? '收合' : '展開');
    });
  }

  function syncHero() {
    qa(
      document,
      '.glg-home-shell[data-app-shell-embedded="true"],[data-glg-home-shell][data-app-shell-embedded="true"]'
    ).forEach(function (shell) {
      shell.setAttribute(
        'data-campaign-contract',
        'home-campaign-v4.25-geo-generator-delivery-loop'
      );
      shell.setAttribute('data-main-ia-lock', 'v4.25-geo-generator-delivery-loop');
      setText(q(shell, '[data-lcm-kicker]'), HERO.kicker);
      setText(q(shell, '[data-lcm-title]'), HERO.title);
      setText(q(shell, '[data-lcm-subtitle]'), HERO.subtitle);
      setText(q(shell, '[data-lcm-subtitle-en]'), '');
    });
  }

  function markHost(root) {
    root.setAttribute('data-city-mission-runtime', VERSION);
    root.setAttribute('data-performance-runtime', 'lazy-spatial-deferred-media');
    root.setAttribute('data-result-contract-runtime', 'p0-04-geo-generator-delivery-loop');
    root.setAttribute('data-ai8-runtime', VERSION);
    root.setAttribute('data-fold-slide-runtime', VERSION);
    root.setAttribute('data-fixed-bg-mode', 'true');
    root.setAttribute('data-zone-handle-consistency', 'v4.25');
    root.setAttribute('data-zone-owner', 'glg-market-registry');
    root.setAttribute('data-interaction-quality', 'motionsites-grade');
    root.setAttribute('data-conversion-loop-ready', 'true');

    var host = root.closest(
      '.glg-main-canvas,[data-glg-main-canvas],[data-main-canvas],[data-glg-home-workspace-region]'
    );
    if (host) {
      host.setAttribute('data-glg-main-ia-host', 'true');
      host.setAttribute('data-fixed-bg-mode', 'true');
    }
  }

  function centerNode(node) {
    if (!node || !node.scrollIntoView) return;
    try {
      node.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    } catch (e) {
      try {
        node.scrollIntoView(false);
      } catch (_) {}
    }
  }

  function syncClue(root, c) {
    var visual = q(root, '[data-ai8-clue-visual],[data-city-mission-clue-visual]');
    if (visual) {
      visual.setAttribute('data-scene', c.key);
      visual.setAttribute('data-canonical-scene-handle', c.canonical);
      visual.className = visual.className.replace(/\bis-scene-[^\s]+/g, '').trim();
      visual.classList.add('is-scene-' + c.key);
      pulse(visual);
    }
    root.setAttribute('data-active-market-key', c.key);
    root.setAttribute('data-active-market', c.handle);
    root.setAttribute('data-active-canonical-scene-handle', c.canonical);

    setAvatar(root, c.key, 'observe');
    setText(q(root, '[data-composer-selected-title]'), c.title);
    setText(q(root, '[data-composer-selected-question]'), c.question);
    setText(q(root, '[data-composer-selected-share-line]'), c.share);
    setText(q(root, '[data-ai8-clue-title],[data-city-mission-clue-title]'), CLUE_TITLE);
    setText(q(root, '[data-ai8-clue-copy],[data-city-mission-clue-copy]'), CLUE_COPY);
    setText(q(root, '[data-home-score-result]'), c.score);
  }

  function select(root, chip) {
    if (!root || !chip) return;
    var c = campaignFromChip(chip);

    qa(root, '[data-composer-market-key]').forEach(function (x) {
      x.setAttribute(
        'aria-pressed',
        normalizeZone(attr(x, 'data-composer-market-key')) === c.key ? 'true' : 'false'
      );
    });

    syncClue(root, c);

    qa(root, '[data-home-score-choice]').forEach(function (b) {
      b.setAttribute(
        'aria-pressed',
        normalizeZone(attr(b, 'data-home-score-choice')) === c.key ? 'true' : 'false'
      );
    });

    setStep(root, 'choose');
    setFold(root, 'mission', true);
    centerNode(chip);

    track(root, 'select_scenario', {
      direction: c.key,
      scene_handle: c.canonical,
      conversion_loop: CONVERSION_LOOP.join('>'),
    });
    emit(
      'glg:market:selected',
      {
        key: c.key,
        marketKey: c.key,
        handle: c.handle,
        scene_handle: c.canonical,
        canonicalSceneHandle: c.canonical,
        title: c.title,
        titleZh: c.title,
        question: c.question,
        shareLine: c.share,
      },
      root
    );
  }

  /* Spatial Picker Deferred Loader & Location Pin */
  function loadSpatialPicker(root, cb) {
    if (window.LittleGSpatialPicker && typeof window.LittleGSpatialPicker.init === 'function') {
      cb && cb();
      return;
    }

    var existing = document.querySelector('script[data-littleg-spatial-picker-loader]');
    if (existing) {
      existing.addEventListener(
        'load',
        function () {
          cb && cb();
        },
        { once: true }
      );
      existing.addEventListener(
        'error',
        function () {
          setText(
            q(root, '[data-littleg-composer-status]'),
            '地圖暫時載入不到；仍可先生成任務卡。'
          );
        },
        { once: true }
      );
      return;
    }

    var url = attr(root, 'data-spatial-script-url');
    if (!url) {
      setText(q(root, '[data-littleg-composer-status]'), '地圖模組未設定；仍可先生成任務卡。');
      return;
    }

    root.setAttribute('data-spatial-loader-state', 'loading');
    var s = document.createElement('script');
    s.src = url;
    s.async = true;
    s.defer = true;
    s.setAttribute('data-littleg-spatial-picker-loader', 'true');

    s.onload = function () {
      root.setAttribute('data-spatial-loader-state', 'ready');
      cb && cb();
    };

    s.onerror = function () {
      root.setAttribute('data-spatial-loader-state', 'error');
      setText(q(root, '[data-littleg-composer-status]'), '地圖暫時載入不到；仍可先生成任務卡。');
    };

    document.head.appendChild(s);
  }

  function spatial(root) {
    var state = {};
    if (window.LittleGSpatialPicker && typeof window.LittleGSpatialPicker.getState === 'function') {
      state = window.LittleGSpatialPicker.getState(root) || {};
    }
    var place = q(root, '[data-spatial-place-input]');
    var lat = q(root, 'input[data-spatial-lat]');
    var lng = q(root, 'input[data-spatial-lng]');

    state.place_hint = state.place_hint || (place && place.value.trim()) || '';
    state.lat = state.lat || (lat && lat.value) || '';
    state.lng = state.lng || (lng && lng.value) || '';
    state.ready = !!(state.lat && state.lng);
    return state;
  }

  function placeText(s) {
    if (!s || (!s.place_hint && !s.lat && !s.lng)) return DEFAULT_PLACE;
    var p = [];
    if (s.place_hint) p.push(s.place_hint);
    if (s.lat && s.lng) p.push(Number(s.lat).toFixed(5) + ', ' + Number(s.lng).toFixed(5));
    p.push('Context only');
    return p.join(' · ');
  }

  function inputValue(root, c) {
    var n = q(root, '[data-littleg-composer-input],[data-littleg-command-input]');
    var v = n ? n.value.trim() : '';
    return v || c.question || '我發現一個城市小發現';
  }

  function updatePinFeedback(root, state) {
    var d = q(root, '[data-spatial-drawer]');
    var t = q(root, '[data-spatial-toggle]');
    var status = q(root, '[data-littleg-composer-status]');

    if (d)
      d.setAttribute(
        'data-spatial-pin-ready',
        state && state.spatial_brief_ready ? 'true' : 'false'
      );
    if (t && state && state.spatial_brief_ready) setText(t, '已插城市 pin');
    if (status && state && state.spatial_brief_ready)
      setText(status, '已插城市 pin；可以得到任務卡。');
  }

  /* Repo A Contract & Canonical GProperty / GCityPartners Handoffs */
  function buildContract(item, c, id) {
    return {
      contract_version: 'p0-04-geo-generator-delivery-loop',
      source: 'city_mission',
      repo_a_owner: 'littleg-project-composer.js',
      repo_b_owner: 'gcity-core-api / glg-spatial-survey-report',
      canonical_endpoint: '/api/delivery/manual-review/create',
      required_gateway: 'GCityExecutor / gcity-core-api',
      result_id: id,
      delivery_type: 'tool',
      delivery_method: 'instant_local',
      output_type: 'mission_card',
      result_surface: 'result-history',
      scene_handle: item.scene_handle,
      legacy_scene_key: c.key,
      local_only: true,
      requires_login: false,
      requires_checkout: false,
      requires_gfun: false,
      repo_b_expected: true,
      frontend_direct_worker_call_allowed: false,
      formal_report_generation_allowed: false,
      cloudflare_sync_status: 'not_synced',
      conversion_loop: CONVERSION_LOOP,
      result_url: item.result_href,
      delivery_url: item.delivery_href,
      generator_url: item.generator_href,
      checkout_url: item.checkout_href,
      review_url: item.professional_review_url,
      created_at: item.created_at,
    };
  }

  function build(root) {
    var c = campaignFromChip(activeChip(root));
    var s = spatial(root);
    var id = uid();
    var issue = inputValue(root, c);
    var canonical = canonicalSceneHandle(c.key);

    /* Canonical Architecture Route Locks */
    var wall =
      attr(root, 'data-wall-url') ||
      attr(root, 'data-result-history-url') ||
      '/pages/result-history';
    var dl = attr(root, 'data-download-center-url') || '/pages/download';
    var review = attr(root, 'data-handoff-url') || '/pages/gcitypartners';
    var gen =
      attr(root, 'data-generator-url') ||
      '/pages/gproperty-map?owner=map&workspace=map&intent=explore_space';
    var checkout = attr(root, 'data-checkout-url') || '/collections';

    var item = {
      result_id: id,
      result_type: 'city-mission-card',
      type: 'city-mission-card',
      status: 'ready',
      result_status: 'local_ready',
      source: 'glg-home-main',
      repo_a_source: 'littleg-project-composer',
      repo_b_expected: true,
      cloudflare_sync_status: 'not_synced',
      delivery_type: 'tool',
      delivery_method: 'instant_local',
      output_type: 'mission_card',
      result_surface: 'result-history',
      conversion_loop: CONVERSION_LOOP,
      conversion_stage: 'citizen_to_gis_to_ai_to_shopify_delivery',
      audit_framework: 'ai8-geo-generator-delivery-v1',
      audit_questions: AUDIT_QUESTIONS,
      commerce_status: 'shopify_checkout_required_for_paid_report',
      delivery_contract_status: 'local_ready_backend_not_synced',
      card_header: CARD_HEADER,
      card_title: CARD_TITLE,
      title: CARD_HEADER,
      summary: issue,
      observation: issue,
      market_key: c.key,
      market_handle: c.handle,
      scene: c.key,
      zone: c.key,
      legacy_scene_key: c.key,
      scene_handle: canonical,
      canonical_scene_handle: canonical,
      direction_label: c.title,
      share_line: c.share,
      share_text: c.share,
      badge_display_name: c.badge,
      badge_name: c.badgeName,
      certificate_title:
        attr(root, 'data-certificate-title') || 'LittleG +0.01% Mission Certificate',
      certificate_issuer: attr(root, 'data-certificate-issuer') || 'LittleG 小量博士',
      lottery_display_text: attr(root, 'data-lottery-display-text') || '已獲得空間情報抽選資格',
      challenge_line: attr(root, 'data-challenge-text') || CHALLENGE,
      card_summary: attr(root, 'data-generated-card-summary') || SUMMARY,
      place_hint: s.place_hint || '',
      lat: s.lat || '',
      lng: s.lng || '',
      map_pin_status: s.ready ? 'selected' : 'not_selected',
      spatial_brief_ready: !!s.ready,
      created_at: new Date().toISOString(),
      saved_at: new Date().toISOString(),
      card_aspect: '9x16',
      export_format: 'png',
      requires_login: false,
      requires_checkout: false,
      requires_gfun: false,
      evidence_status: 'local / pending formal submission',
    };

    item.result_href = append(wall, {
      source: 'glg-home-main',
      result_id: id,
      intent: 'city-plus-one-wall',
      direction: c.key,
      scene_handle: canonical,
    });
    item.delivery_href = append(dl, {
      source: 'glg-home-main',
      result_id: id,
      direction: c.key,
      scene_handle: canonical,
      output_type: 'mission_card',
    });
    item.generator_href = append(gen, {
      source: 'glg-home-main',
      intent: 'geo-generator',
      result_id: id,
      scene_handle: canonical,
      legacy_scene_key: c.key,
    });
    item.checkout_href = append(checkout, {
      source: 'glg-home-main',
      intent: 'shopify-digital-delivery',
      result_id: id,
      scene_handle: canonical,
    });

    /* GCityPartners B2B Brief Form Direct Anchor Handoff */
    item.professional_review_url = append(
      review,
      {
        source: 'glg-home-main',
        intent: 'review-brief',
        result_id: id,
        market: c.handle,
        zone: c.key,
        scene_handle: canonical,
        legacy_scene_key: c.key,
        observation: issue,
        place_hint: s.place_hint || '',
        lat: s.lat || '',
        lng: s.lng || '',
      },
      'gcp-brief-form'
    );

    item.share_url = append(
      '/',
      {
        source: 'share',
        intent: 'city-mission-card',
        scene: c.key,
        scene_handle: canonical,
        ref: id,
      },
      'littleg-city-mission'
    );
    item.contract = buildContract(item, c, id);

    return item;
  }

  function save(item) {
    var r = read(RESULT_KEY, []);
    var d = read(DELIVERY_KEY, []);
    if (!Array.isArray(r)) r = [];
    if (!Array.isArray(d)) d = [];
    r.unshift(item);
    d.unshift(Object.assign({}, item, { status: 'ready' }));
    write(RESULT_KEY, r.slice(0, 80));
    write(DELIVERY_KEY, d.slice(0, 80));
    write(LATEST_KEY, item);
  }

  function setAspect(root, aspect) {
    aspect = aspect === '16x9' ? '16x9' : '9x16';
    var card = q(root, '[data-littleg-composer-card]');
    var p = q(root, '[data-card-aspect-target]');
    if (card) card.setAttribute('data-current-aspect', aspect);
    if (p) p.setAttribute('data-aspect', aspect);

    qa(root, '[data-littleg-card-aspect-option]').forEach(function (b) {
      b.setAttribute(
        'aria-pressed',
        attr(b, 'data-littleg-card-aspect-option') === aspect ? 'true' : 'false'
      );
    });

    if (root.__lastCard) {
      root.__lastCard.card_aspect = aspect;
      write(LATEST_KEY, root.__lastCard);
    }
  }

  function showReward(root, item) {
    var r = q(root, '[data-ai8-reward-preview],[data-city-mission-reward-preview]');
    setAvatar(root, item.market_key, 'complete');
    setStep(root, 'done');
    if (!r) return;

    r.hidden = false;
    r.removeAttribute('hidden');
    setText(q(r, '[data-ai8-reward-title],[data-city-mission-reward-title]'), 'Dr.G 收到！');
    setText(
      q(r, '[data-ai8-reward-copy],[data-city-mission-reward-copy]'),
      '你的城市 +0.01% 卡已完成。'
    );
    pulse(r);

    try {
      r.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } catch (e) {}
  }

  function updateCard(root, item) {
    root.__lastCard = item;
    root.setAttribute('data-card-ready', 'true');
    root.setAttribute('data-last-result-id', item.result_id);
    root.setAttribute('data-last-scene-handle', item.scene_handle);
    root.setAttribute('data-conversion-stage', 'delivery-ready');

    setText(q(root, '[data-littleg-composer-card-title]'), item.card_title);
    setText(q(root, '[data-littleg-composer-card-finding]'), item.observation);
    setText(q(root, '[data-littleg-composer-card-place]'), placeText(item));
    setText(q(root, '[data-littleg-composer-card-task]'), item.share_line);
    setText(q(root, '[data-littleg-composer-card-badge-display-name]'), item.badge_display_name);
    setText(q(root, '[data-littleg-composer-card-badge-name]'), item.badge_name);
    setText(q(root, '[data-littleg-composer-card-certificate]'), item.certificate_title);
    setText(q(root, '[data-littleg-composer-card-issuer]'), item.certificate_issuer);
    setText(q(root, '[data-littleg-composer-card-challenge]'), item.challenge_line);
    setText(q(root, '[data-littleg-composer-card-lottery]'), item.lottery_display_text);
    setText(q(root, '[data-littleg-composer-card-summary]'), item.card_summary);

    setText(q(root, '[data-export-title]'), item.card_title);
    setText(q(root, '[data-export-direction]'), item.direction_label);
    setText(q(root, '[data-export-finding]'), item.observation);
    setText(q(root, '[data-export-share]'), item.share_line);
    setText(q(root, '[data-export-challenge]'), item.challenge_line);

    var result = q(root, '[data-littleg-composer-card-result]');
    var delivery = q(root, '[data-littleg-composer-card-delivery]');
    var review = q(root, '[data-littleg-composer-card-review]');
    var generator = q(root, '[data-littleg-composer-card-generator]');

    if (result) result.href = item.result_href;
    if (delivery) delivery.href = item.delivery_href;
    if (review) review.href = item.professional_review_url;
    if (generator) generator.href = item.generator_href;

    showReward(root, item);

    var card = q(root, '[data-littleg-composer-card]');
    if (card) {
      card.hidden = false;
      card.removeAttribute('hidden');
      card.classList.remove('is-revealing');
      void card.offsetWidth;
      card.classList.add('is-revealing');
      setTimeout(function () {
        card.classList.remove('is-revealing');
      }, 980);
      setAspect(root, item.card_aspect);
    }
  }

  function submit(root) {
    setFold(root, 'mission', true);
    setMotion(root, 'generating');
    var item = build(root);
    save(item);
    updateCard(root, item);

    try {
      document.documentElement.setAttribute('data-pwa-result-ready', 'true');
    } catch (e) {}

    setMotion(root, 'complete', {
      result_id: item.result_id,
      direction: item.market_key,
      scene_handle: item.scene_handle,
      conversion_loop: item.conversion_loop.join('>'),
    });
    track(root, 'generate_card', {
      direction: item.market_key,
      scene_handle: item.scene_handle,
      result_id: item.result_id,
      spatial_brief_ready: item.spatial_brief_ready,
      cloudflare_sync_status: item.cloudflare_sync_status,
      conversion_stage: item.conversion_stage,
    });

    setText(
      q(root, '[data-littleg-composer-status]'),
      item.spatial_brief_ready
        ? '已得到任務卡，城市 pin 也保存了。'
        : '已得到任務卡；也可以再插一個城市 pin。'
    );
    emit('gcity:result-envelope:ready', item.contract, root);
    emit('littleg:composer:submit', item, root);
  }

  function toggleSpatial(root) {
    var d = q(root, '[data-spatial-drawer]');
    if (!d) return;

    var open = d.getAttribute('data-collapsed') === 'true';
    d.setAttribute('data-collapsed', open ? 'false' : 'true');

    var t = q(d, '[data-spatial-toggle]');
    if (t) {
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      setText(t, open ? '正在載入城市 pin…' : '插 pin：我在這裡發現');
    }

    if (open) {
      setStep(root, 'pin');
      loadSpatialPicker(root, function () {
        if (t) setText(t, '城市 pin 已打開');
        if (window.LittleGSpatialPicker && typeof window.LittleGSpatialPicker.init === 'function') {
          window.LittleGSpatialPicker.init(root);
          setTimeout(function () {
            if (root.__littlegMap && root.__littlegMap.invalidateSize)
              root.__littlegMap.invalidateSize();
          }, 220);
        }
      });
    }
  }

  function reset(root) {
    var i = q(root, '[data-littleg-composer-input]');
    if (i) i.value = '';

    var card = q(root, '[data-littleg-composer-card]');
    var reward = q(root, '[data-ai8-reward-preview],[data-city-mission-reward-preview]');
    var drawer = q(root, '[data-spatial-drawer]');

    if (card) {
      card.hidden = true;
      card.setAttribute('hidden', '');
    }
    if (reward) {
      reward.hidden = true;
      reward.setAttribute('hidden', '');
    }
    if (drawer) drawer.setAttribute('data-spatial-pin-ready', 'false');

    root.setAttribute('data-card-ready', 'false');
    root.setAttribute('data-conversion-stage', 'reset');

    setMotion(root, 'reset');
    select(root, activeChip(root));
    setStep(root, 'look');
    setText(q(root, '[data-littleg-composer-status]'), '準備開始：定位地點，即時產出空間評估。');
  }

  /* Share & HD Canvas 2D Export Engine (Mapbox Studio Aligned) */
  function copy(txt) {
    if (navigator.clipboard && navigator.clipboard.writeText)
      return navigator.clipboard.writeText(txt);
    var a = document.createElement('textarea');
    a.value = txt;
    a.style.position = 'fixed';
    a.style.top = '-999px';
    document.body.appendChild(a);
    a.select();
    document.execCommand('copy');
    document.body.removeChild(a);
    return Promise.resolve();
  }

  function copyChallenge(root) {
    var item = root.__lastCard || read(LATEST_KEY, null) || build(root);
    var url = item.share_url;
    try {
      url = new URL(url || '/', location.origin).toString();
    } catch (e) {}

    copy([item.challenge_line, item.share_line, url].filter(Boolean).join('\n')).then(function () {
      setText(q(root, '[data-littleg-composer-status]'), '挑戰文案已複製。');
    });
  }

  function lines(ctx, text, max, limit) {
    var src = String(text || '').trim();
    var cjk = /[\u3400-\u9fff]/.test(src);
    var arr = cjk ? src.split('') : src.split(/\s+/);
    var out = [];
    var line = '';

    arr.forEach(function (t) {
      if (out.length >= limit) return;
      var n = cjk ? line + t : line ? line + ' ' + t : t;
      if (ctx.measureText(n).width <= max) {
        line = n;
      } else {
        if (line) out.push(line);
        line = t;
      }
    });

    if (line && out.length < limit) out.push(line);
    return out;
  }

  function exportCard(root, aspect) {
    var item = root.__lastCard || read(LATEST_KEY, null) || build(root);
    aspect = aspect === '16x9' ? '16x9' : '9x16';

    var c = document.createElement('canvas');
    var v = aspect !== '16x9';
    c.width = v ? 1080 : 1600;
    c.height = v ? 1920 : 900;

    var x = c.getContext('2d');
    var w = c.width;
    var h = c.height;

    /* Mapbox Slate & Blue Background Mesh */
    var g = x.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#f8fafc'); /* Slate 50 */
    g.addColorStop(0.46, '#e2e8f0'); /* Slate 200 */
    g.addColorStop(1, '#cbd5e1'); /* Slate 300 */
    x.fillStyle = g;
    x.fillRect(0, 0, w, h);

    var rg = x.createRadialGradient(w * 0.82, h * 0.1, 20, w * 0.82, h * 0.1, w * 0.52);
    rg.addColorStop(0, 'rgba(0, 96, 255, 0.22)'); /* Mapbox Electric Blue Glow */
    rg.addColorStop(0.42, 'rgba(148, 163, 184, 0.12)');
    rg.addColorStop(1, 'rgba(255, 255, 255, 0)');
    x.fillStyle = rg;
    x.fillRect(0, 0, w, h);

    /* Grid Texture Lines */
    x.fillStyle = 'rgba(15, 23, 42, 0.04)';
    for (var i = 0; i < w; i += 80) x.fillRect(i, 0, 1, h);
    for (var j = 0; j < h; j += 80) x.fillRect(0, j, w, 1);

    /* Inner Glass Card Panel */
    x.fillStyle = 'rgba(255, 255, 255, 0.88)';
    x.fillRect(52, 52, w - 104, h - 104);
    x.strokeStyle = 'rgba(15, 23, 42, 0.08)';
    x.lineWidth = 2;
    x.strokeRect(52, 52, w - 104, h - 104);

    /* Typography & Text Rendering */
    x.fillStyle = '#0f172a';
    x.textBaseline = 'top';
    x.font =
      '700 ' +
      (v ? 34 : 30) +
      'px ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace';
    x.fillText(CARD_HEADER, 72, 68);

    x.font =
      '800 ' + (v ? 98 : 82) + 'px -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    lines(x, CARD_TITLE, v ? 900 : 760, 3).forEach(function (l, n) {
      x.fillText(l, 72, (v ? 184 : 148) + n * (v ? 112 : 92));
    });

    x.font =
      '700 ' +
      (v ? 42 : 34) +
      'px ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace';
    x.fillStyle = '#0060ff';
    x.fillText('場景 · ' + item.direction_label, 72, v ? 548 : 340);

    x.fillStyle = '#0f172a';
    x.font =
      '600 ' + (v ? 54 : 40) + 'px -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    lines(x, item.observation, v ? 900 : 620, v ? 5 : 4).forEach(function (l, n) {
      x.fillText(l, v ? 72 : 900, (v ? 660 : 128) + n * (v ? 68 : 52));
    });

    x.font =
      '800 ' + (v ? 52 : 40) + 'px -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    lines(x, item.share_line, v ? 900 : 1240, v ? 3 : 2).forEach(function (l, n) {
      x.fillText(l, 72, (v ? 1300 : 570) + n * (v ? 64 : 52));
    });

    x.font =
      '600 ' +
      (v ? 30 : 24) +
      'px ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace';
    x.fillStyle = '#64748b';
    x.fillText(item.challenge_line, 72, v ? 1588 : 718);
    x.fillText('OSM context only · not a formal report', 72, v ? 1770 : 786);

    var name = 'littleg-city-mission-' + aspect + '-' + item.result_id + '.png';

    function downloadFile(url) {
      var a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }

    if (c.toBlob) {
      c.toBlob(function (b) {
        var u = URL.createObjectURL(b);
        downloadFile(u);
        setTimeout(function () {
          URL.revokeObjectURL(u);
        }, 1200);
      }, 'image/png');
    } else {
      downloadFile(c.toDataURL('image/png'));
    }

    setMotion(root, 'exported', {
      aspect: aspect,
      result_id: item.result_id,
      scene_handle: item.scene_handle,
    });
    track(root, 'download_card', {
      aspect: aspect,
      result_id: item.result_id,
      scene_handle: item.scene_handle,
    });

    var ex = read(EXPORT_KEY, []);
    if (!Array.isArray(ex)) ex = [];
    ex.unshift({
      result_id: item.result_id,
      scene_handle: item.scene_handle,
      aspect: aspect,
      filename: name,
      at: new Date().toISOString(),
    });
    write(EXPORT_KEY, ex.slice(0, 50));

    try {
      window.dispatchEvent(new CustomEvent('littleg:share-card:exported', { detail: item }));
    } catch (e) {}
  }

  /* Lifecycle Mount & Event Delegation */
  function scrollToComposer(btn) {
    var shell = btn && btn.closest ? btn.closest('[data-glg-home-shell]') : null;
    var target = (shell && q(shell, ROOT)) || q(document, ROOT);
    if (!target) return false;

    try {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {}
    setTimeout(function () {
      try {
        target.focus({ preventScroll: true });
      } catch (e) {}
    }, 300);
    return true;
  }

  function mount(root) {
    if (!root || root.getAttribute('data-composer-mounted') === VERSION) return;
    root.setAttribute('data-composer-mounted', VERSION);

    markHost(root);
    syncFolds(root);
    select(root, activeChip(root));
    setStep(root, 'look');

    qa(root, '[data-lgc-fold]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        syncFolds(root);
        track(root, 'toggle_fold', { fold: attr(d, 'data-lgc-fold'), open: d.open });
      });
    });

    root.addEventListener('input', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-littleg-composer-input]')) {
        setStep(root, 'write');
      }
    });

    root.addEventListener('littleg:spatial:updated', function (e) {
      updatePinFeedback(root, e.detail || {});
      if (e.detail && e.detail.spatial_brief_ready) setStep(root, 'pin');
    });

    root.addEventListener('click', function (e) {
      var t = e.target;
      var chip = t.closest && t.closest('[data-composer-market-key]');
      var score = t.closest && t.closest('[data-home-score-choice]');
      var st = t.closest && t.closest('[data-spatial-toggle]');
      var sub = t.closest && t.closest('[data-littleg-composer-submit]');
      var resetBtn = t.closest && t.closest('[data-littleg-composer-reset]');
      var copyBtn = t.closest && t.closest('[data-littleg-copy-share]');
      var exp = t.closest && t.closest('[data-littleg-export-card]');
      var asp = t.closest && t.closest('[data-littleg-card-aspect-option]');
      var close = t.closest && t.closest('[data-littleg-composer-card-close]');

      if (chip && root.contains(chip)) {
        e.preventDefault();
        select(root, chip);
        return;
      }
      if (score && root.contains(score)) {
        e.preventDefault();
        var c = qa(root, '[data-composer-market-key]').filter(function (x) {
          return (
            normalizeZone(attr(x, 'data-composer-market-key')) ===
            normalizeZone(attr(score, 'data-home-score-choice'))
          );
        })[0];
        if (c) select(root, c);
        setFold(root, 'score', true);
        return;
      }
      if (st && root.contains(st)) {
        e.preventDefault();
        toggleSpatial(root);
        return;
      }
      if (sub && root.contains(sub)) {
        e.preventDefault();
        submit(root);
        return;
      }
      if (resetBtn && root.contains(resetBtn)) {
        e.preventDefault();
        reset(root);
        return;
      }
      if (copyBtn && root.contains(copyBtn)) {
        e.preventDefault();
        copyChallenge(root);
        return;
      }
      if (exp && root.contains(exp)) {
        e.preventDefault();
        exportCard(root, attr(exp, 'data-littleg-export-card'));
        return;
      }
      if (asp && root.contains(asp)) {
        e.preventDefault();
        setAspect(root, attr(asp, 'data-littleg-card-aspect-option'));
        return;
      }
      if (close && root.contains(close)) {
        e.preventDefault();
        var card = q(root, '[data-littleg-composer-card]');
        var reward = q(root, '[data-ai8-reward-preview],[data-city-mission-reward-preview]');
        if (card) {
          card.hidden = true;
          card.setAttribute('hidden', '');
        }
        if (reward) {
          reward.hidden = true;
          reward.setAttribute('hidden', '');
        }
        root.setAttribute('data-card-ready', 'false');
      }
    });
  }

  function bindStart(scope) {
    qa(scope || document, '[data-ai8-start-composer],[data-city-mission-action="start"]').forEach(
      function (b) {
        if (b.__ai8Start) return;
        b.__ai8Start = true;
        b.addEventListener('click', function (e) {
          if (scrollToComposer(b)) {
            e.preventDefault();
            document.documentElement.setAttribute('data-littleg-first-click', 'composer');
          }
        });
      }
    );
  }

  function boot(scope) {
    syncHero();
    qa(scope || document, ROOT).forEach(mount);
    bindStart(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
        setTimeout(function () {
          boot(document);
        }, 160);
      },
      { once: true }
    );
  } else {
    boot(document);
    setTimeout(function () {
      boot(document);
    }, 160);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
  document.addEventListener('shopify:section:select', function (e) {
    boot(e.target || document);
  });
  window.addEventListener('glg:market-registry:ready', function () {
    boot(document);
  });
})();
